<!-- <div class="bg-[#491176] min-h-screen">
    <portals-navbar></portals-navbar> -->
    <div class="flex items-center justify-center heightB pb-[76px]">
        <div class="text-center flex flex-col items-center">
          <h1 class="font-bold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">Thanks for reaching out</h1>
          <h2 *ngIf="!emailSent" class="text-white" style="font-family: 'Roboto', sans-serif; font-weight: 100;">
            Include your email and we’ll be in touch in a hot minute.
          </h2>
          <div *ngIf="!emailSent && !emailSending" class="inputWButtion">
            <form [formGroup]="emailForm" (ngSubmit)="sendEmail()">
              <input
                type="email"
                formControlName="email"
                required
                class="custom-input border-2 border-[#fbd364] bg-transparent box-border text-white font-roboto text-center"
                placeholder="Enter email"
              />
              <button
                type="submit"
                class="submit-button py-[10px] rounded-xl font-bold"
                style="background-color: #fbd364; color: #491176; border-radius: 100px"
              >
                Submit
              </button>
            </form>
            <div *ngIf="errorMessage" class="text-red-500 mt-2">{{ errorMessage }}</div>
          </div>
          <div *ngIf="emailSent" class="font-bold text-[#FBD354]" style="font-family: 'Roboto', sans-serif;">
            Thank you! We will be in touch soon.
          </div>
          <div *ngIf="emailSending" class="text-white">Sending email...</div>
        </div>
      </div>
      
      